import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';
import Overlay from '../Miscelania/Overlay';
import moment from 'moment';

class FlightReportRefuelsRequestAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      approval_required: 0,
      export_required: 0,
      aircraft_id: '',
      helitank_id: '',
      helitank_option: '',
      last_type: 'select',
      date: '',
      flight_report_id: '',
      flight_report_leg_id: '',
      maintenance_association: false,
      extra_flight: false,
      internal_storage_tank: 0,
      fuel_supplier_id: '',
      refuel_reason_id: '',
      location_id: '',
      requested: '',
      comments: '',
      company_id: '',
      address: '',
      staff_id: '',
      next_location_id: '',
      water_check_before: '',
      water_check_during: '',
      water_check_after: '',
      fuel_type_id: '',
      fuel_unity: '',
      base_id: '',
      remaining_fuel_quantity: '',
      required_fuel_for_next_flight: '',
      required_fuel_in_liters: '',
      fuel_per_tank: '',
      aircrafts_select: [],
      helitank_select: [],
      flight_reports_select: [],
      flight_report_legs_select: [],
      locations_select: [],
      flight_report_legs: [],
      flight_report_refuels: [],
      flight_report_refuels_table: [],
      fuel_suppliers_select: [],
      fuel_types_select: [],
      refuel_reasons_select: [],
      companies_select: [],
      staff_select: [],
      flight_report_refuel_edit: {},
      water_check_select: [
        {value: 'Clear', label: 'Clear'},
        {value: 'Contaminated', label: 'Contaminated'},
      ],
      bases_select: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.updateData = this.updateData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState(change);
  }
  handleToggleExtraFlightChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de internal storage, relatório de voo, trecho, localidade de destino e associação a voo de manutenção
    this.setState({
      helitank_id: '',
      helitank_option: '',
      last_type: 'select',
      internal_storage_tank: 0,
      flight_report_id: null,
      flight_report_leg_id: null,
      next_location_id: null,
      maintenance_association: 0,
    });
    
  }
  handleToggleInternalStorageChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de aeronave, relatório de voo, trecho, localidade de destino e associação a voo de manutenção
    this.setState({
      helitank_id: '',
      helitank_option: '',
      last_type: 'select',
      aircraft_id: null,
      flight_report_id: null,
      flight_report_leg_id: null,
      next_location_id: null,
      maintenance_association: 0,
    });

  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeReport(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var self = this;
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');

      change['requested'] = '';
      
      if(self.state.flight_report_legs[event.value]) {
        change['flight_report_legs_select'] = self.state.flight_report_legs[event.value];
      } else {
        change['flight_report_legs_select'] = [];
      }
      if(self.state.flight_report_refuels[event.value]) {
        change['flight_report_refuels_table'] = self.state.flight_report_refuels[event.value];
      } else {
        change['flight_report_refuels_table'] = [];
      }
      
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/basic/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.aircraft_id,
            fuel_type_id: responseJson.data.aircraft.aircraft_model.fuel_type_id,
            fuel_unity: '('+responseJson.data.aircraft.aircraft_model.fuel_unity.abbreviation+')',
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.main.id,
            fuel_type_id: responseJson.data.main.aircraft_model.fuel_type_id,
            fuel_unity: '('+responseJson.data.main.aircraft_model.fuel_unity.abbreviation+')',
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            locations_select: responseJson.data.locations_select,
            location_id: responseJson.data.flight_report_leg.departure_location_id,
            next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
            reading_start: responseJson.data.flight_report_leg.fuel_start
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            approval_required: responseJson.data.main.refuel_approval_required,
            export_required: responseJson.data.main.refuel_export_required,
            staff_id: '',
            requested: '',
            address: '',
            next_location_id: '',
            water_check_before: '',
            water_check_during: '',
            water_check_after: '',
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  changeLastInput(type) {
    this.setState({
      last_type: type,
    });
  }

  updateData() {
    var change = {};
    if(this.state.flight_report_refuels[this.state.flight_report_id]) {
        change['flight_report_refuels_table'] = this.state.flight_report_refuels[this.state.flight_report_id];
    } else {
        change['flight_report_refuels_table'] = [];
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/solicitacao/abastecimento/listas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            helitank_select: responseJson.data.helitank_select,
            locations_select: responseJson.data.locations_select,
            flight_reports_select: responseJson.data.flight_reports_select,
            flight_report_legs: responseJson.data.flight_report_legs_select,
            flight_report_refuels: responseJson.data.flight_report_refuels,
            fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
            fuel_types_select: responseJson.data.fuel_types_select,
            refuel_reasons_select: responseJson.data.refuel_reasons_select,
            companies_select: responseJson.data.companies_select,
            staff_select: responseJson.data.staff_select,
            bases_select: responseJson.data.bases_select,
            date: responseJson.data.date,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    var datasave = new FormData();
    datasave.append("helitank_id", this.state.helitank_id);
    datasave.append("helitank_option", this.state.helitank_option);
    datasave.append("last_type", this.state.last_type);
    datasave.append("aircraft_id", this.state.aircraft_id);
    datasave.append("flight_report_id", this.state.flight_report_id);
    datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
    datasave.append("maintenance_association", this.state.maintenance_association);
    datasave.append("extra_flight", this.state.extra_flight);
    datasave.append("internal_storage_tank", this.state.internal_storage_tank);
    datasave.append("location_id", this.state.location_id);
    datasave.append("company_id", this.state.company_id);
    datasave.append("date", this.state.date);
    datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
    datasave.append("refuel_reason_id", this.state.refuel_reason_id);
    datasave.append("requested", this.state.requested);
    datasave.append("comments", this.state.comments);
    datasave.append("address", this.state.address);
    datasave.append("staff_id", this.state.staff_id);
    datasave.append("next_location_id", this.state.next_location_id);
    datasave.append("water_check_before", this.state.water_check_before);
    datasave.append("water_check_during", this.state.water_check_during);
    datasave.append("water_check_after", this.state.water_check_after);
    datasave.append("base_id", this.state.base_id);
    datasave.append("remaining_fuel_quantity", this.state.remaining_fuel_quantity);
    datasave.append("required_fuel_for_next_flight", this.state.required_fuel_for_next_flight);
    datasave.append("required_fuel_in_liters", this.state.required_fuel_in_liters);
    datasave.append("fuel_per_tank", this.state.fuel_per_tank);
    datasave.append("fuel_type_id", this.state.fuel_type_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/solicitacao/abastecimento', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: datasave }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/abastecimento/solicitacao/editar/' + responseJson.data.flight_report_refuel.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.updateData();
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;

    this.setState(change);
  }

  formFields(fields_type) {

    var fields = '';

    if (fields_type == 0) {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Motivo}:</label>
              <Select
                className="form-field-name"
                name="refuel_reason_id"
                value={this.state.refuel_reason_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
                options={this.state.refuel_reasons_select}
                required
              />
            </div>
            <div className="col-md-6 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado} {this.state.fuel_unity}:</label>
                <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"} className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comentarios}:</label>
              <textarea style={{ height: 100 }} type="text" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
            </div>
          </div>
        </div>
      );
    } else {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Motivo}:</label>
              <Select
                className="form-field-name"
                name="refuel_reason_id"
                value={this.state.refuel_reason_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
                options={this.state.refuel_reasons_select}
                required
              />
            </div>
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado} {this.state.fuel_unity}:</label>
              <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"} className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required />
            </div>
            {(this.state.extra_flight === false) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comandante}</label>
                  <Select
                    className="form-field-name"
                    name="staff_id"
                    value={this.state.staff_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'staff_id')}
                    options={this.state.staff_select}
                  />
              </div>
            }
          </div>

          <div className="row">
            {(this.state.extra_flight === false) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.ProximaLocalidade}:</label>
                  <Select
                    className="form-field-name"
                    name="next_location_id"
                    value={this.state.next_location_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                    options={this.state.locations_select}
                  />
              </div>
            }
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                  disabled={this.state.internal_storage_tank === 0 ? true : false}
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <label>Comments</label>
              <textarea style={{ height: 100 }} type="text" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
            </div>
          </div>

        </div>
      );
    }

    return fields;

  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-fluid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.solicitar}</h3>
        <Link to="/abastecimentos/solicitacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.add}>
            <div className="row">
              <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Data}:</label>
                <InputMask value={this.state.date} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.general.diaMesAno} required />
              </div>
              <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Fornecedor}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_supplier_id"
                  value={this.state.fuel_supplier_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
                  options={this.state.fuel_suppliers_select}
                  required
                />
              </div>
              <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Empresa}:</label>
                <Select
                  className="form-field-name"
                  name="company_id"
                  value={this.state.company_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeCompany.bind(this, 'company_id')}
                  options={this.state.companies_select}
                  required
                  />
              </div>
              <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Base}:</label>
                <Select
                  className="form-field-name"
                  name="base_id"
                  value={this.state.base_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'base_id')}
                  options={this.state.bases_select}
                  required
                  />
              </div>
              <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AbastecimentoExtraVoo}?</label>
                <br/>
                <Toggle
                  checked={this.state.extra_flight}
                  name="extra_flight"
                  onChange={this.handleToggleExtraFlightChange.bind(this, 'extra_flight')}
                  />
              </div>
              {(this.state.extra_flight === 1) &&
                <div className="col-md-2 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TanqueArmazenamentoInterno}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.internal_storage_tank}
                    name="internal_storage_tank"
                    onChange={this.handleToggleInternalStorageChange.bind(this, 'internal_storage_tank')}
                  />
                </div>
              }
            </div>
            <div className="row">
              {(this.state.internal_storage_tank === 1) && (
                    self.state.last_type === 'input' ?
                      <div className="col-md-6 form-group">
                        <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                        <br/>
                        <input type="text" name="helitank_option" className="form-control" placeholder="" value={this.state.helitank_option} onChange={this.handleChange.bind(this, 'helitank_option')} required />
                      </div>
                    : 
                      <div className="col-md-6 form-group">
                          <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                            <br/>
                            <Select
                              className="form-field-name"
                              name="helitank_id"
                              value={this.state.helitank_id}
                              onChange={this.handleSelectChange.bind(this, 'helitank_id')}
                              options={this.state.helitank_select}
                              placeholder={'Selecione'}
                            />
                      </div>
              )}
              {(this.state.extra_flight === 1) ?
                    <div>
                      {(this.state.internal_storage_tank === 0) &&
                        <div className="col-md-4 form-group">
                            <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Aeronave}:</label>
                            <Select
                                className="form-field-name"
                                name="aircraft_id"
                                value={this.state.aircraft_id}
                                searchable={true}
                                placeholder={this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.placeholder.SelecioneAeronave}
                                onChange={this.handleSelectChangeAircraft.bind(this, 'aircraft_id')}
                                options={this.state.aircrafts_select}
                                required
                            />
                        </div>
                      }
                      <div className="col-md-4 form-group">
                          <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade}:</label>
                          <Select
                            className="form-field-name"
                            name="location_id"
                            value={this.state.location_id}
                            searchable={true}
                            placeholder={'Selecione'}
                            onChange={this.handleSelectChange.bind(this, 'location_id')}
                            options={this.state.locations_select}
                            required
                          />
                      </div>
                      {(this.state.internal_storage_tank === 0) &&
                        <div className="col-md-4 form-group">
                          <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AssociarManutencao}?</label>
                          <br/>
                          <Toggle
                            checked={this.state.maintenance_association}
                            name="maintenance_association"
                            onChange={this.handleToggleChange.bind(this, 'maintenance_association')}
                          />
                        </div>
                      }
                    </div>
                  :
                      <div>
                        <div className="col-md-4 form-group">
                            <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Relatorio}:</label>
                            <Select
                                className="form-field-name"
                                name="flight_report_id"
                                value={this.state.flight_report_id}
                                searchable={true}
                                placeholder={'Selecione'}
                                onChange={this.handleSelectChangeReport.bind(this, 'flight_report_id')}
                                options={this.state.flight_reports_select}
                                required
                            />
                        </div>
                        <div className="col-md-4 form-group">
                            <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Trecho}:</label>
                            <Select
                                className="form-field-name"
                                name="flight_report_leg_id"
                                value={this.state.flight_report_leg_id}
                                searchable={true}
                                placeholder={'Selecione'}
                                onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
                                options={this.state.flight_report_legs_select}
                                required
                            />
                        </div>
                        <div className="col-md-4 form-group">
                            <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade}:</label>
                            <Select
                              className="form-field-name"
                              name="location_id"
                              value={this.state.location_id}
                              searchable={true}
                              placeholder={'Selecione'}
                              onChange={this.handleSelectChange.bind(this, 'location_id')}
                              options={this.state.locations_select}
                              required
                            />
                        </div>
                      </div>
              }
            </div>
            {this.formFields(this.state.export_required)}
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.botaoAdicionarSolicitacao}</button>
        </form>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsRequestAdd;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsRequestAdd.js